/* eslint-disable @typescript-eslint/no-explicit-any */
// Default locale object to use as fallback when getLocale() returns null/undefined
export const defaultLocale: any = {
  simpleHeader: {
    placeholder: '',
  },
  authV2: {
    login: {
      text: {
        title: '',
        description: '',
        link: '',
      },
      submitButton: '',
    },
    recovery: {},
    register: {},
  },
  register: {
    logIn: {},
    withProxyErrors: () => '',
    fail: '',
    success: { LOG_IN: '' },
  },
  firebase: {},
  addresses: {},
  confirmation: {
    title: '',
    text: '',
    lswOff: '',
    followup: {
      text: '',
      link: '',
    },
    goBack: '',
    textMultipleOrders: '',
  },
  filter: {
    sort: {
      minorToMajorPrice: '',
      majorToMinorPrice: '',
      minorToMajorName: '',
      majorToMinorName: '',
      minorToMajorPricePerSubUnit: '',
      majorToMinorPricePerSubUnit: '',
      minorToMajorExternalCreationDate: '',
      majorToMinorExternalCreationDate: '',
      minorToMajorPromotionActive: '',
      orderBy: '',
    },
    aggregates: {
      priceRanges: '',
      tags: '',
      OnSale: '',
      categories: '',
      brands: '',
    },
    orderBy: '',
    brandBy: '',
    categoryBy: '',
    priceBy: '',
    drawerButton: '',
    drawerTitle: '',
    summaryTitle: '',
    showMore: '',
    showLess: '',
    clear: '',
    apply: '',
    gt: '',
    lt: '',
    eq: '',
    ne: '',
    seePromotionalProducts: '',
    deleteAll: '',
    applySorting: '',
    filterBy: '',
    order: '',
    resultsFor: '',
  },
  showcase: {
    subheader: {
      placeholder: '',
      searchin: (storeName: string) => storeName || '',
    },
  },
  clients: {},
  selectStore: {},
  promos: {
    noProductsFound: '',
  },
  errorCodes: {},
  onePageCheckout: {},
  suggestOpenTheApp: {},
  livestatus: {
    error: {
      notFound: {},
      noToken: {},
    },
  },
  productDetail: {
    broken: {
      title: 'Product not found',
      subtitle: 'The product you are looking for does not exist.',
      btnTxt: 'Go to home',
    },
  },
  cart: {
    suggestedProducts: {},
  },
  rules: {},
  gql: {
    errors: () => '',
  },
  newAddress: {
    createAddress: { error: '' },
  },
  account: {},
  ordersHistory: {},
  lobby: {},
  checkout: {
    submit: {
      normal: '',
      payBefore: '',
    },
    steps: {
      title: '',
      step: '',
      currentStep: '',
    },
  },
  groupedOrders: {
    OrderSummary: '',
    PaymentMethods: {
      title: '',
    },
  },
  terms: () => ({
    text: '',
    link: '',
    title: '',
  }),
  privacy: () => ({
    text: '',
    link: '',
    title: '',
  }),
  messages: {},
  product: {},
  widgets: {},
  seeMore: {},
}

export default defaultLocale
